// Import the mixins
import { BugsnagService } from '@/mixins/services/bugsnag/BugsnagService'

// Import firebase
import { configModel } from '@/firebase/firebase-config'

export const GetInvoiceOptions = {

    /*
	**  Register the mixins
	*/

	mixins: [

        BugsnagService

    ],

    /*
	**  Set up the data
	*/

	data: () => ({

        invoice_options: null

    }),

    /*
	**  Methods
    */
    
    methods: {

        getInvoiceOptionsHandler: async function() {

            // Get the user doc
            configModel.doc('invoice_options').get()
            .then(doc => {

                if (!doc.exists) return;

                /*
                **  Set the doc prop
                **  @prop_location: @here
                */

                this.invoice_options = doc.data();
                

            })
            .catch(error => {

                /*
                **  Send to Bugsnag
                **  @service: Bugsnag/BugsnagService
                */
               
                this.reportAuthBugsnagError({
                    title: 'Get Invoice Options Config from Firestore',
                    errorType: 'Firestore Database',
                    section: 'Events/Config',
                    uid: '4TGv8kOtsx1UxQ08bDQB',
                    error: error
                });

            });

        }

    }

}